import React from "react";

const AccountPage = ({}) => {
    return (
        <div>My Account</div>
    );
};

export default AccountPage;